import React from "react";
import "./App.css";
import { BrowserRouter, Route, Routes, useLocation } from "react-router-dom";
import { Toaster } from "sonner";

import { AuthProvider } from "./context/AuthContext";
import Landing from "./pages/Landing";
import Login from "./pages/Login";
import Register from "./pages/Register";
import Dashboard from "./pages/Dashboard";
import BiodataBuilder from "./pages/BiodataBuilder";
import AuthCallback from "./pages/AuthCallback";
import ProfileEditor from "./pages/ProfileEditor";
import ProfileView from "./pages/ProfileView";
import Search from "./pages/Search";
import PublicSearch from "./pages/PublicSearch";
import Premium from "./pages/Premium";
import AdminPayments from "./pages/AdminPayments";
import AdminSeo from "./pages/AdminSeo";
import Interests from "./pages/Interests";
import AboutUs from "./pages/AboutUs";
import ContactUs from "./pages/ContactUs";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import RefundPolicy from "./pages/RefundPolicy";
import FAQ from "./pages/FAQ";
import Templates from "./pages/Templates";

function AppRouter() {
  const location = useLocation();
  // Emergent Google Auth returns to /dashboard#session_id=... — intercept it
  // synchronously (during render, not in an effect) so we can exchange the
  // session BEFORE the AuthProvider probes /auth/me.
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route path="/" element={<Landing />} />
      <Route path="/login" element={<Login />} />
      <Route path="/register" element={<Register />} />
      <Route path="/dashboard" element={<Dashboard />} />
      <Route path="/biodata/build" element={<BiodataBuilder />} />
      <Route path="/biodata/:id/edit" element={<BiodataBuilder />} />
      <Route path="/profile/edit" element={<ProfileEditor />} />
      <Route path="/profile/:id" element={<ProfileView />} />
      <Route path="/search" element={<Search />} />
      <Route path="/browse" element={<PublicSearch />} />
      <Route path="/about" element={<AboutUs />} />
      <Route path="/contact" element={<ContactUs />} />
      <Route path="/privacy" element={<PrivacyPolicy />} />
      <Route path="/refund" element={<RefundPolicy />} />
      <Route path="/faq" element={<FAQ />} />
      <Route path="/templates" element={<Templates />} />
      <Route path="/premium" element={<Premium />} />
      <Route path="/interests" element={<Interests />} />
      <Route path="/admin/payments" element={<AdminPayments />} />
      <Route path="/admin/seo" element={<AdminSeo />} />
      <Route path="*" element={<Landing />} />
    </Routes>
  );
}

export default function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <AppRouter />
          <Toaster richColors position="top-center" />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}
